import { Divider, Page, Stack, Text } from "@towersystems/roam-common-native";
import { useTranslation } from "../../../../utilities/i18n";
import { StockCountCompletedRootParamList } from "../../../../types";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import {
  StockCountItem,
  StockCountLine,
} from "@towersystems/roam-common/lib/generated-types";
import React from "react";
import { useStockCountCompletedContext } from "../../utils/stocktake-completed/hooks";
import { FlatList } from "react-native";
import { Spacings, View } from "react-native-ui-lib";
import { formatDateToCalendar } from "@towersystems/roam-common/lib/shared-utils";

export type StockCountCompletedCountHistoryScreenProp = NativeStackScreenProps<
  StockCountCompletedRootParamList,
  "StockCountCompletedCountHistoryScreen"
>;

export const StockCountCompletedCountHistoryScreen = ({
  route,
}: StockCountCompletedCountHistoryScreenProp) => {
  const [stockCountLine, setStockCountLine] = React.useState<
    StockCountLine | undefined
  >(undefined);
  const { t } = useTranslation("stock_counts");

  const { stockCountLines } = useStockCountCompletedContext();

  React.useEffect(() => {
    let matching = stockCountLines.find(
      (line) => line.id === route.params.lineId
    );
    if (matching) {
      setStockCountLine(matching);
    }
  }, []);

  const renderItem = React.useCallback(({ item }: { item: StockCountItem }) => {
    return (
      <View
        flex
        row
        style={{
          justifyContent: "space-between",
          maxWidth: "100%",
          overflow: "hidden",
          alignItems: "center",
        }}
      >
        <Stack vertical spacing={1}>
          <Text>{item.counted} counted</Text>
          <Text color="subdued">{formatDateToCalendar(item.countedAt)}</Text>
        </Stack>
      </View>
    );
  }, []);

  if (!stockCountLine) {
    return <Page title={t("count_history")}></Page>;
  }

  return (
    <Page title={t("count_history")} secondaryTitle={stockCountLine.barcode}>
      <FlatList
        scrollEnabled={true}
        data={stockCountLine.items}
        renderItem={renderItem}
        keyExtractor={(item) => item.id.toString()}
        initialNumToRender={20}
        windowSize={3}
        ItemSeparatorComponent={Divider}
      />
    </Page>
  );
};
